import slick from 'slick-carousel';
import { Slider } from './js/slider';

let slider = new Slider('#slider');
slider.options.arrows = true;
slider.init();
